;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "62RuQDcfMx"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  var $this = jQuery(this);
  function setPaddingBG() {
      var $dom = $this.find('.lh-heading');
      if($dom.hasClass('lh-check-lazy')) return;
      var img_bg = $dom.css('background-image');
      if(img_bg.includes('url')){
        var url = img_bg.match(/\(\"?\'?([^\"\'\(]+)\"?\'?\)/);
        if(url)
        {
          var img = new Image();
          img.onload = function() {
            var pb = (this.height / this.width * 100) + "%";
            $dom.css({
              'height': 0,
              'padding-bottom': pb
            });
            window.LAYOUTHUB_LIVE && $dom.addClass('lh-check-lazy');
            $dom.hasClass('lh-lazy-loaded') && $dom.addClass('lh-check-lazy');
          }
          img.src = url[1];
        }
      }
  };
  var count = 0;
  function animateImg(event) {
      count++;
      if(count % 15 != 0) return;
      var w_top   = $(window).scrollTop(),
      __this      = $(event.currentTarget) ,
      _this_w     = __this.width(),
      _ratio      = _this_w / 20,
      _offset_l   = __this.offset().left,
      _offset_t   = __this.offset().top,
      _m_x        = event.originalEvent.pageX,
      _m_y        = event.originalEvent.pageY
      _x_new      = (_offset_l - _m_x) / _ratio,
      _y_new      = (_offset_t - _m_y) / _ratio;
      __this.find('.lh-content-main').css({'top': _y_new, 'left': _x_new});
  }
  function setOrigin(event){
    var __this  = $(event.currentTarget),
    img         = __this.find('.lh-content-main');
    img.removeAttr('style');
  }

  $(window).resize(function(){
    setPaddingBG();
    var w_w = $(window).width();
    var item = $this.find('.lh-heading');
    if(w_w >= 1200){
      if(!item.hasClass('lh-added-event')){
        item.addClass('lh-added-event');
        item.mousemove(animateImg);
        item.mouseleave(setOrigin);
      }
    }else{
      item.unbind();
      item.removeClass('lh-added-event');
    }
  }).trigger('resize');
 };						cb.bind($('section[data-section-id="62RuQDcfMx"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="62RuQDcfMx"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/DB0n6ewo4aLVZHrR/content/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "1plyVa9IgR"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="1plyVa9IgR"]').get(0))({						url: "https://library.layouthub.com/HUB/files/U2VwLS0yMDIw/NTk5NDQ1MzA1/shopify-third-release/pages/DB0n6ewo4aLVZHrR/workprocess/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "9dprd5sxm7"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="9dprd5sxm7"]').get(0))({						url: "https://library.layouthub.com/HUB/files/RmViLS0yMDIx/NjEzNzA2NjU3/release-2-2021/pages/ZmHEruNeFAW5Gfd8/call-to-action/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "bgjagmt8kpc"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="bgjagmt8kpc"]').get(0))({						url: "https://library.layouthub.com/HUB/files/Tm92LS0yMDIw/NjA0NTYwMTE4/release-11-2020/pages/dy9Cu0tcV4KjoIsO/makeup/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');